export enum PermissionsEnums {
  Employee_Calendar_VIEW_MY_DEPARTMENT_ABSENCES = 'Employee Calendar - View My Department Absences',
  FEATUREESS_TIMECARD = 'FeatureESS Timecard',
  FEATUREJOB_COSTING_FUNCTION = 'FeatureJob Costing function',
  PARTIAL_ABSENCES_EDIT = 'Partial Absences-Edit',
  FEATUREEMPLOYEE_CALENDAR = 'FeatureEmployee Calendar',
  ESSLOGINPERMISSION = 'EssLoginPermission',
  FEATUREREPORTS = 'FeatureReports',
  FEATURESCHEDULING_WITH_LABOR_ALLOCATION = 'FeatureScheduling with Labor Allocation',
  FEATUREREPORTGROUP_DEFAULT_REPORTS = 'FeatureReportGroup Default Reports',
  EMPLOYEE_SELF_SERVICE = 'Employee Self Service',
  ESS_CHANGE_PASSWORD = 'ESS Change Password',
  FEATURESCHEDULING_FUNCTION = 'FeatureScheduling function',
  FEATUREACCRUALS_FUNCTION = 'FeatureAccruals function',
  FEATUREMOBILE_PUNCH = 'FeatureMobile Punch',
  NOTIFICATIONS_EDIT = 'Notifications-Edit',
  EMPLOYEE_PROFILE_SHOW_DEFAULT_JOB = 'Employee Profile - Show Default Job',
  SHOW_NOTIFICATION_MENU = 'Show Notification Menu',
  FEATUREDEPARTMENT_ALLOCATION_FUNCTION = 'FeatureDepartment Allocation function',
  ADD_EMPLOYEES = 'Add Employees',
  DELETE_EMPLOYEES = 'Delete employees',
  ADMIN_MODULE_EMP_IMPORT = 'Administration Module-Employee Import',
  ADMIN_MODULE_AUDIT_CONFIG = 'Administration Module-Audit Configuration',
  ALLOW_CLEAR_SCHEDULES = 'Allow Clear Schedules',
  ALLOW_DEPARTMENT_NOTIFICATION_OVERRIDES = 'Allow Department Notification Overrides',
  DESTRUCTIVE_RECALC = 'Allow Destructive Recalc',
  DAILY_SIGNOFF = 'Allow Daily Sign Off',
  APPROVE_LOANED_TIME = 'Approve Loaned Time',
  CHANGE_RECORD_LOCKDATE = 'Change Record Lock Date',
  CONFIG_ADMIN = 'Configuration - Admin',
  CONFIG_DATA = 'Configuration - Data',
  DEPARTMENT_PREMIUMS_EDIT = 'Department Premiums Edit',
  DISABLE_SCHEDULE_RECORD = 'Disable Schedule Record',
  EMP_DEPT_RATES_EDIT = 'Employee Department Rates Edit',
  EMP_JOB_RATES_EDIT = 'Employee Job Rates Edit',
  EMP_SCHED_ABSENCE_EDIT = 'EmployeeSchedAbsence-Edit',
  EMP_PROFILE_PREMIUMS_EDIT = 'Employee Profile Premiums Edit',
  EMP_RATES_EDIT = 'Employee Rates Edit',
  SHIFTMATCH_EDIT = 'ShiftMatch-Edit',
  SM_NOTES_EDIT = 'ShiftMatchReason-Edit',
  SM_NOTES_VIEW = 'ShiftMatchReason-View',
  SS_NOTES_EDIT = 'ShiftScheduleNotes-Edit',
  SS_NOTES_VIEW = 'ShiftScheduleNotes-View',
  BET_NOTES_VIEW = 'BenefitEmployeeTransNotes-View',
  BET_NOTES_EDIT = 'BenefitEmployeeTransNotes-Edit',
  BENEFITEMPLOYEE_EDIT = 'BenefitEmployee-Edit',
  BENEFITEMPLOYEE_TRANS_EDIT = 'BenefitEmployeeTrans-Edit',
  EDIT_EMP_PIC = 'Update Employee Picture',
  WTS_FILL_WITH_SCH = 'WTS Fill With Schedule',
  WTS_COPY_LAST_WEEK = 'WTS Copy Last Week',
  WTS_SUBMIT_TO_SUP = 'WTS Submit To Supervisor',
  DEPT_ALL_VIEW = 'vDepartmentAll-View',
  EMP_ALL_VIEW = 'vEmployeeLookupAll-View',
  VIS_VIEW_ALL_DEPTS = 'Visibility-ViewAllDepts',
  DISPLAY_EMPLOYEE_PROFILE_ACCRUALS_INFO = 'Display Employee Profile Accruals Info',
  EMP_HR_INFO_EDIT = 'EmployeeHRInfo-Edit',
  SHOW_PERIOD_SIGNOFF_LINK_TCE = 'ShowPeriodSignoffLinkToTCE',
  SHOW_PERIOD_SIGNOFF_ADDITIONAL_EMPLOYEE_FIELD = 'PeriodSignoff.ShowAdditionalEmployeeField',
  BYPASS_TIMECAT_FILTERING = 'Bypass TimeCat Filtering',
  USER_EDITS = 'User Edits',
  SHOW_WEEKLY_TOTALS = 'Show Weekly Totals',
  ACCRUAL_SUMMARY_NONVISIBLE_READONLY_ACCESS = 'Accrual Summary Non-Visible ReadOnly Access',
  UPDATE_LABOR_ALLOCATION_INFO = 'Update Labor Allocation Info',
  SHOW_TASKQ_WARNING = 'Show TaskQ Warning',
  WORK_TIME_OVERRIDES_EDIT = 'WorkTimeOverrides-Edit',
  WORK_TIME_PREFERENCES_EDIT = 'WorkTimePreferences-Edit',
  SHOW_ABSENCE_REQUESTS_IN_MESSAGE_CENTER = 'ShowAbsenceRequestsInMessageCenter',
  WTS_ALLOW_EDITING_TCE = 'WTS Allow Editing in TCE',
  WTS_INPUT_EXPENSE = 'WTS Input Expense',
  FEATURE_SCHEDULE_EMPLOYEE_ABSENCES = 'FeatureSchedule employee absences',
  FEATURE_WEB_PUNCH = 'FeatureWeb Punch',
  FEATURE_ABSENCE_REQUEST = 'FeatureAbsence Request',
  FEATURE_TIMESHEET = 'FeatureTimesheet',
  SYSTEM_INFO_SHOW_FEATURE_ENABLED_COLUMN = 'System Info Show Feature Enabled Column',
  SHOW_DATABASE_NAME = 'Show Database Name',
  USER_TRAINING_ENABLE_EDIT_MODE = 'User Training - Enable Edit Mode',
  QUERY_EDIT = 'Allow Query Edit',
  QUERY_SHOW_ADDRESS_WR = 'QSS - Show Address and WR Options',
  QUERY_SHOW_EXCEPTION_GROUPS = 'QSS.ShowExceptionGroups',
  REPORTS_VIEW_SHARED_PREFERENCES = 'Reports - View Shared Preferences',
  REPORTS_EDIT_SHARED_PREFERENCES = 'Reports - Update Shared Preferences',
  EMP_DOCUMENTS_UPLOAD = 'Employee Documents - Upload',
  EMP_DOCUMENTS_DELETE = 'Employee Documents - Delete',
  UE_FULL_SHIFT_ABSENCE = 'UE Full Shift Absence',
  UE_MISSED_TIME = 'UE Missed Time',
  UE_PARTIAL_ABSENCE = 'UE Partial Absence',
  UE_WORKED_THROUGH_LUNCH = 'UE Worked Through Lunch',
  UE_CHANGE_TC_CREATE = 'UE Change TC - Create',
  UE_CHANGE_TC_MODIFY = 'UE Change TC - Modify',
  UE_CHANGE_TC_DELETE = 'UE Change TC - Delete',
  UE_MANUAL_REPLACE_CREATE = 'UE Manual Replace - Create',
  UE_MANUAL_REPLACE_MODIFY = 'UE Manual Replace - Modify',
  UE_MANUAL_REPLACE_DELETE = 'UE Manual Replace - Delete',
  UE_MANUAL_TRANS_TIME = 'UE Manual Trans - Time',
  UE_MANUAL_TRANS_ABSENCE = 'UE Manual Trans - Absence',
  UE_MANUAL_TRANS_ABSENCE_LATE_ENTRY = 'UE Manual Trans - Absence - Late Entry',
  UE_MANUAL_TRANS_ABSENCE_EARLY_EXIT = 'UE Manual Trans - Absence - Early Exit',
  UE_MANUAL_TRANS_MEMO = 'UE Manual Trans - Memo',
  UE_MANUAL_TRANS_PREMIUM = 'UE Manual Trans - Premium',
  UE_MANUAL_TRANS_PREMIUM_FIXED_AMOUNT = 'UE Manual Trans - Premium-FixedAmount',
  SHIFT_SCHEDULE_EDIT = 'ShiftSchedule-Edit',
  FEATURE_SCHEDULE_COVERAGE = 'FeatureSchedule Coverage',
  SHOW_PREFERENCES = 'Show Preferences',
  EMP_ABS_REQ_APPROVAL = 'Employee Calendar Absence Request Approval',
  V_EMPLOYEE_PUBLIC_EDIT = 'vEmployeePublic-Edit',
  V_EMPLOYEE_PRIVATE_EDIT = 'vEmployeePrivate-Edit',
  V_EMPLOYEE_CORPORATE_EDIT = 'vEmployeeCorporate-Edit',
  V_EMPLOYEE_NOTES_EDIT = 'vEmployeeNotes-Edit',
  V_EMPLOYEE_QUALIFICATIONS_EDIT = 'vEmployeeQualifications-Edit',
  V_EMPLOYEE_RATE_EDIT = 'vEmployeeRate-Edit',
  JOIN_EMPLOYEE_BADGE_VIEW = 'joinEmployeeBadge-View',
  JOIN_EMPLOYEE_BADGE_EDIT = 'joinEmployeeBadge-Edit',
  JOIN_EMPLOYEE_PERIOD_EDIT = 'joinEmployeePeriod-Edit',
  JOIN_EMPLOYEE_RULE_EDIT = 'joinEmployeeRule-Edit',
  EMP_APP_ACCESS_VIEW = 'Employee Profile - Application Access-View',
  EMP_APP_ACCESS_EDIT = 'Employee Profile - Application Access-Edit',
  EMP_CLOCK_DETAILS_VIEW = 'Employee Profile - Clock Details-View',
  EMP_CLOCK_DETAILS_EDIT = 'Employee Profile - Clock Details-Edit',
  FEATUREDISPLAY_LABELS = 'FeatureDisplay Labels',
  EP_QUICK_ADD_PAGE = 'Employee Profile - Quick Add Page',
  NOTIFICATION_ATTACHMENTS = 'Notification Attachments',
  WTS_EXPENSE_ATTACHMENTS = 'WTS Expense Attachments',
  FEATURE_SHIFT_OFFER = 'FeatureShift Offer',
}
